import AcquireTokenCallback from '../schema/AcquireTokenCallback';
import acquireTokenFromAuthContext from './acquireTokenFromAuthContext';
import AuthenticationContext from 'adal-angular';

export let aquireTokenAfterLogin = (
    authContext: AuthenticationContext,
    resource: string,
    authChallenge: string,
    getAccessTokenCallback: AcquireTokenCallback
) => (loginError: string | null, idToken: string | null): void => {
    if (loginError || !idToken) {
        getAccessTokenCallback(loginError, null /* token */);
    } else {
        authContext.getCachedUser();
        acquireTokenFromAuthContext(authContext, resource, authChallenge, getAccessTokenCallback);
    }
};
